import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";

export interface LanguageOption {
  code: string;
  name: string;
}

/**
 * Common language options for ElevenLabs API
 * Based on ISO 639-3 language codes supported by ElevenLabs
 */
export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: "auto", name: "Auto-detect" },
  { code: "ara", name: "Arabic" },
  { code: "asm", name: "Assamese" },
  { code: "ben", name: "Bengali" },
  { code: "zho", name: "Chinese" },
  { code: "cze", name: "Czech" },
  { code: "dut", name: "Dutch" },
  { code: "eng", name: "English" },
  { code: "fra", name: "French" },
  { code: "deu", name: "German" },
  { code: "guj", name: "Gujarati" },
  { code: "hin", name: "Hindi" },
  { code: "hun", name: "Hungarian" },
  { code: "ita", name: "Italian" },
  { code: "jpn", name: "Japanese" },
  { code: "kan", name: "Kannada" },
  { code: "kor", name: "Korean" },
  { code: "mal", name: "Malayalam" },
  { code: "mar", name: "Marathi" },
  { code: "nep", name: "Nepali" },
  { code: "ori", name: "Odia" },
  { code: "pol", name: "Polish" },
  { code: "por", name: "Portuguese" },
  { code: "pan", name: "Punjabi" },
  { code: "rus", name: "Russian" },
  { code: "spa", name: "Spanish" },
  { code: "tam", name: "Tamil" },
  { code: "tel", name: "Telugu" },
  { code: "tur", name: "Turkish" },
  { code: "urd", name: "Urdu" },
];

interface LanguageSelectorProps {
  value?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * LanguageSelector Component
 * 
 * Dropdown component for selecting language for transcription.
 * Defaults to "auto-detect" which lets ElevenLabs detect the language automatically.
 */
export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  value = "auto",
  onValueChange,
  disabled = false,
  className = "",
}) => {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <label className="text-xs font-extralight text-muted-foreground">
        Language
      </label>
      <Select
        value={value}
        onValueChange={onValueChange}
        disabled={disabled}
      >
        <SelectTrigger className="w-full bg-input border-gray-300 font-extralight text-sm">
          <SelectValue placeholder="Select language" />
        </SelectTrigger>
        <SelectContent>
          {LANGUAGE_OPTIONS.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

